import styled from 'styled-components';

const ContactStyle = styled.div`
	--cMaxWidth: var(--sp86x);
	--cMarginTop: var(--sp25x);
	--cTitleMarginBottom: var(--sp5x);
	--cSubtitleMarginBottom: var(--sp5x);
	--cSuccessPanelSizes: var(--sp7x);
	--cSuccessPanelMarginRight: var(--sp4x);
	--cSuccessIconSize: var(--sp3x);

	.contact-container {
		max-width: var(--cMaxWidth);
		margin: var(--cMarginTop) auto var(--cMarginTop);

		.success-container {
			display: flex;
			justify-content: center;
			align-items: center;
			padding-top: var(--cMarginTop);
			background-color: var(--secondaryColor1);
			text-align: left;

			.success-message {
				margin-bottom: var(--sp0-5x);
			}

			.success-panel {
				display: flex;
				justify-content: center;
				align-items: center;
				min-width: var(--cSuccessPanelSizes);
				min-height: var(--cSuccessPanelSizes);
				background-color: var(--successColor);
				margin-right: var(--cSuccessPanelMarginRight);
				clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);

				.success-icon {
					color: var(--primaryColor3);
					font-size: var(--cSuccessIconSize);
				}
			}
		}

		.contact-title {
			margin-bottom: var(--cTitleMarginBottom);
			text-align: center;
		}

		.contact-subtitle {
			margin-bottom: var(--cSubtitleMarginBottom);
			text-align: center;
		}

		.global-error {
			margin-bottom: var(--cSubtitleMarginBottom);
			text-align: center;
		}

		.contact-form {
			display: flex;
			flex-direction: column;

			.ant-select {
				.ant-select-selector {
					width: 100%;
					font-size: 16px;
					border-radius: var(--inputBorderRadius);
					border: 1px solid var(--secondaryColor4);
					outline: none;
					background-color: var(--primaryColor3);

					.ant-select-selection-item {
						font-size: var(--pS);
					}

					.ant-select-selection-placeholder {
						color: var(--secondaryColor2);
						font-family: var(--ping);
						font-weight: 400;
						font-size: var(--pS);
					}
				}

				&.ant-select-status-error {
					.ant-select-selector {
						border-color: var(--errorColor);

						.ant-select-selection-placeholder {
							color: var(--errorColor);
						}
					}
				}
			}

			.contact-btn {
				display: inline-flex;
				align-self: flex-end;

				> button {
					padding: 0;
				}
			}

			textarea {
				resize: none;
			}

			.ant-input-textarea-suffix {
				display: none;
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--cMaxWidth: var(--sp64x);
		--cMarginTop: var(--sp20x);
		--cTitleMarginBottom: var(--sp4x);
		--cSubtitleMarginBottom: var(--sp5x);
		--cSuccessPanelSizes: var(--sp7x);
		--cSuccessPanelMarginRight: var(--sp3x);
		--cSuccessIconSize: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--cMaxWidth: var(--sp50x);
		--cMarginTop: var(--sp20x);
		--cTitleMarginBottom: var(--sp3x);
		--cSubtitleMarginBottom: var(--sp5x);
		--cSuccessPanelSizes: var(--sp5x);
		--cSuccessPanelMarginRight: var(--sp3x);
		--cSuccessIconSize: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--cMaxWidth: var(--sp48x);
		--cMarginTop: var(--sp10x);
		--cTitleMarginBottom: var(--sp3x);
		--cSubtitleMarginBottom: var(--sp4x);
		--cSuccessPanelSizes: var(--sp5x);
		--cSuccessPanelMarginRight: var(--sp3x);
		--cSuccessIconSize: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--cMaxWidth: var(--sp51x);
		--cMarginTop: var(--sp10x);
		--cTitleMarginBottom: var(--sp3x);
		--cSubtitleMarginBottom: var(--sp4x);
		--cSuccessPanelSizes: var(--sp5x);
		--cSuccessPanelMarginRight: var(--sp3x);
		--cSuccessIconSize: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--cMaxWidth: var(--sp44x);
		--cMarginTop: var(--sp10x);
		--cTitleMarginBottom: var(--sp3x);
		--cSubtitleMarginBottom: var(--sp4x);
		--cSuccessPanelSizes: var(--sp5x);
		--cSuccessPanelMarginRight: var(--sp2x);
		--cSuccessIconSize: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--cMaxWidth: var(--sp64x);
		--cMarginTop: var(--sp10x);
		--cTitleMarginBottom: var(--sp3x);
		--cSubtitleMarginBottom: var(--sp4x);
		--cSuccessPanelSizes: var(--sp5x);
		--cSuccessPanelMarginRight: var(--sp2x);
		--cSuccessIconSize: var(--sp2x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--cMaxWidth: 100%;
		--cMarginTop: var(--sp10x);
		--cTitleMarginBottom: var(--sp3x);
		--cSubtitleMarginBottom: var(--sp4x);
		--cSuccessPanelSizes: var(--sp5x);
		--cSuccessPanelMarginRight: var(--sp2x);
		--cSuccessIconSize: var(--sp2x);
	}
`;

export default ContactStyle;
